/**
 * Dictionnaire UNIQUE des statuts affichés (système de design, docs/design/systeme-de-design.md) :
 * code du serveur → libellé français + ton de la pastille. Un écran n'affiche jamais un code brut
 * (« CANCELLED », « IN_ESCROW », « KYC: VERIFIED ») : il passe par statusInfo() ou <StatusPill>.
 *
 * Tons : attente · argent (paiement en jeu) · route · succes · danger · neutre · info.
 */

const S = (label, tone) => ({ label, tone });

export const STATUSES = {
  // Missions (backend/mission_states.py, VALID_TRANSITIONS)
  mission: {
    PENDING:         S('En attente', 'attente'),
    PAYMENT_PENDING: S('Paiement à faire', 'argent'),
    RESERVED:        S('Réservée, paiement retenu', 'argent'),
    ACCEPTED:        S('Acceptée', 'info'),
    IN_ESCROW:       S('Paiement sécurisé', 'argent'),
    IN_TRANSIT:      S('En route', 'route'),
    DELIVERED:       S('Livrée', 'succes'),
    COMPLETED:       S('Terminée', 'succes'),
    DISPUTED:        S('Litige', 'danger'),
    CANCELLED:       S('Annulée', 'neutre'),
  },
  // Propositions
  proposition: {
    PENDING:   S('En attente de réponse', 'attente'),
    ACCEPTED:  S('Acceptée', 'succes'),
    REJECTED:  S('Refusée', 'danger'),
    WITHDRAWN: S('Retirée', 'neutre'),
    EXPIRED:   S('Expirée', 'neutre'),
  },
  // Paiements (collection payments)
  paiement: {
    PENDING:    S('En attente', 'attente'),
    RESERVED:   S('Réservé, non débité', 'argent'),
    AUTHORIZED: S('Autorisé', 'argent'),
    IN_ESCROW:  S('Retenu', 'argent'),
    RELEASED:   S('Versé au transporteur', 'succes'),
    REFUNDED:   S('Remboursé', 'neutre'),
    FAILED:     S('Échec', 'danger'),
    CANCELLED:  S('Annulé', 'neutre'),
  },
  // Versements au transporteur (backend/transfers.py)
  versement: {
    SCHEDULED:       S('Programmé', 'attente'),
    WAITING_ACCOUNT: S('En attente du compte', 'attente'),
    SENDING:         S('En cours', 'route'),
    SENT:            S('Versé', 'succes'),
    SIMULATED:       S('Simulé', 'neutre'),
    FAILED:          S('Échec', 'danger'),
    CANCELLED:       S('Annulé', 'neutre'),
  },
  // Colis et trajets (backend/listing_states.py)
  annonce: {
    DRAFT:          S('Brouillon', 'neutre'),
    PENDING_REVIEW: S('En validation', 'attente'),
    PUBLISHED:      S('Publiée', 'succes'),
    ACTIVE:         S('Publiée', 'succes'),
    FULL:           S('Complet', 'info'),
    IN_PROGRESS:    S('En route', 'route'),
    DELIVERED:      S('Livrée', 'succes'),
    COMPLETED:      S('Terminée', 'succes'),
    DISPUTED:       S('Litige', 'danger'),
    CANCELLED:      S('Annulée', 'neutre'),
    EXPIRED:        S('Expirée', 'neutre'),
    REJECTED:       S('Refusée par la modération', 'danger'),
    ARCHIVED:       S('Archivée', 'neutre'),
  },
  // Pièce d'identité (kyc_status)
  identite: {
    NONE:        S('Non envoyée', 'neutre'),
    PENDING:     S("En cours d'examen", 'attente'),
    IN_PROGRESS: S("En cours d'examen", 'attente'),
    VERIFIED:    S('Vérifiée', 'succes'),
    REJECTED:    S('Refusée', 'danger'),
  },
};

const INCONNU = S('Statut inconnu', 'neutre');

/** { label, tone } d'un statut ; jamais le code brut, même pour un code inconnu. */
export function statusInfo(domain, code) {
  if (domain === 'identite' && !code) return STATUSES.identite.NONE;
  return STATUSES[domain]?.[code] || INCONNU;
}

export const ROLE_LABELS = {
  ROLE_SENDER: 'Expéditeur',
  ROLE_CARRIER: 'Transporteur',
  ROLE_ADMIN: 'Administrateur',
};

/** Libellé d'un rôle (« ROLE_CARRIER » → « Transporteur »). */
export const roleLabel = (role) => ROLE_LABELS[role] || 'Rôle inconnu';
